import React, { useRef, useState } from "react";
import ImportantTerms from "./ImportantTerms";
import axios from "axios";
import CourierSelectionRate from "./CourierSelectionRate";
import costEstimationimg from "../../../assets/undraw_our_solution_re_8yk6 1.png";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
// import { toast } from "react-toastify";
import { FiChevronDown } from "react-icons/fi";
import { Notification } from "../../../Notification";
const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const CostEstimation = () => {
  const resultSectionRef = useRef(null);
  const [formData, setFormData] = useState({
    shipmentType: "Forward",
    pickUpPincode: "",
    deliveryPincode: "",
    weight: "",
    declaredValue: "",
    paymentType: "Prepaid",
    dimensions: { length: "", breadth: "", height: "" },
  });
  const [courierData, setCourierData] = useState([]); // Store API response
  const [isDataFetched, setIsDataFetched] = useState(false); // Boolean for data status
  const [loading, setLoading] = useState(true); // Loader state
  const [hasFetched, setHasFetched] = useState(true); // Track if fetch was attempted
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.startsWith("dimensions")) {
      const dimensionKey = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        dimensions: {
          ...prev.dimensions,
          [dimensionKey]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Convert dimensions to numbers for calculation
    const length = Number(formData.dimensions.length);
    const breadth = Number(formData.dimensions.breadth);
    const height = Number(formData.dimensions.height);
    const actualWeight = Number(formData.weight);

    // Calculate volumetric weight
    const volumetricWeight = (length * breadth * height) / 5000;

    // Determine applicable weight (whichever is greater)
    const applicableWeight = Math.max(actualWeight, volumetricWeight);

    // Updated payload
    const requestData = {
      ...formData,
      applicableWeight, // Add applicable weight
    };
    try {
      setLoading(true);
      setHasFetched(true); // Set flag to true when fetching starts
      const token=Cookies.get("session");
      const response = await axios.post(
        `${REACT_APP_BACKEND_URL}/ratecalculate/Rate`,
        requestData,
        {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("Form Data Submitted:", response.data);
      if (response.data[0].forward.finalCharges === null) {
        Notification("Pincode serviceability is not available","info");
      } else {
        // console.log("Form Data Submitted:", response.data);
      }
      // toast.success("Form Data Submitted")
      setCourierData(response.data); // Store API response

      setIsDataFetched(true); // Mark data as fetched
      // Auto-scroll to the result section
      setTimeout(() => {
        resultSectionRef.current?.scrollIntoView({ behavior: "smooth" });
      }, 300);
    } catch (error) {
      console.log("Error submitting form:", error);
      setIsDataFetched(false);
    } finally {
      setLoading(false);
      setHasFetched(false);
    }
  };

  return (
    <div className="py-2 sm:px-2">
      <div className="mb-4">
        <h1 className="text-[12px] md:text-[18px] font-[600] text-gray-700">
          Shipping Rates Calculator
        </h1>
        {/* <div className="text-sm">
          <span className="text-gray-500">Home</span> &gt;
          <span className="text-[#2d054b]">Cost Estimates</span>
        </div> */}
      </div>

      <div className="sm:bg-white mx-auto w-full max-w-full rounded-lg sm:shadow-sm sm:p-4 flex flex-col md:flex-row lg:shadow-[0_2px_8px_rgba(12,187,125,0.3)] md:shadow-sm ">
        {/* Form Section - Left Side */}
        <form
          onSubmit={handleSubmit}
          className="space-y-4 w-full md:w-1/2 pr-0 md:pr-8"
        >
          <div className="grid grid-cols-2 gap-6">
            {/* Pick-up Area Pincode */}
            <div>
              <label className="block font-[600] mb-2 text-gray-500 text-[12px]">
                Pick-up Area Pincode <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="pickUpPincode"
                required
                value={formData.pickUpPincode}
                onChange={handleChange}
                placeholder="6 Digits Pick-up Area Pincode"
                pattern="^\d{6}$"
                maxLength="6"
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                className="w-full border border-gray-300 rounded-lg px-3 h-9 bg-gray-50 placeholder:text-[12px] text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
              />
            </div>

            {/* Delivery Area Pincode */}
            <div>
              <label className="block font-[600] mb-2 text-gray-500 text-[12px]">
                Delivery Area Pincode <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                name="deliveryPincode"
                required
                value={formData.deliveryPincode}
                onChange={handleChange}
                placeholder="6 Digits Delivery Area Pincode"
                pattern="^\d{6}$"
                maxLength="6"
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/\D/g, "");
                }}
                title="Please enter exactly 6 digits"
                className="w-full border border-gray-300 rounded-lg px-3 h-9 bg-gray-50 placeholder:text-[12px] text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
              />
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 mt-4">
            {/* Approximate Weight */}
            <div>
              <label className="block font-[600] mb-2 text-gray-500 text-[12px]">
                Approximate Weight <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center w-full rounded-lg bg-gray-50 overflow-hidden">
                <input
                  type="text"
                  name="weight"
                  required
                  value={formData.weight}
                  onChange={handleChange}
                  placeholder="E.g. 1"
                  inputMode="decimal"
                  pattern="^\d*\.?\d*$"
                  onKeyDown={(e) => {
                    const allowedKeys = [
                      "Backspace",
                      "Tab",
                      "ArrowLeft",
                      "ArrowRight",
                      "Delete",
                      ".",
                    ];
                    const isNumber = /\d/.test(e.key);
                    if (!isNumber && !allowedKeys.includes(e.key))
                      e.preventDefault();
                    if (e.key === "." && e.currentTarget.value.includes("."))
                      e.preventDefault();
                  }}
                  className="w-full h-9 px-3 bg-gray-50 placeholder:text-[12px] text-[12px] outline-none border border-gray-300 border-r-0 rounded-l-lg"
                />
                <span className="h-9 px-3 flex items-center justify-center bg-[#632C9D] text-white text-[12px] border border-l border-[#632C9D] rounded-r-lg">
                  kg
                </span>
              </div>
            </div>

            {/* Declared Value */}
            <div>
              <label className="block font-[600] mb-2 text-gray-500 text-[12px]">
                Declared Value in INR <span className="text-red-500">*</span>
              </label>
              <div className="flex items-center w-full overflow-hidden">
                <input
                  type="text"
                  name="declaredValue"
                  required
                  value={formData.declaredValue}
                  onChange={handleChange}
                  placeholder="Declared Value"
                  inputMode="numeric"
                  pattern="^\d*$"
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/\D/g, "");
                  }}
                  className="w-full px-3 h-9 bg-gray-50 border border-gray-300 border-r-0 placeholder:text-[12px] text-[12px] outline-none rounded-l-lg"
                />
                <span className="h-9 px-3.5 flex items-center justify-center bg-[#632C9D] text-white text-[12px] border border-l border-[#632C9D] rounded-r-lg">
                  ₹
                </span>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6 mt-4">
            {/* Payment Type */}
            <div className="relative w-full]">
              <label className="block font-[600] mb-2 text-gray-500 text-[12px]">
                Payment Type <span className="text-red-500">*</span>
              </label>

              <div
                onClick={() => setDropdownOpen(!dropdownOpen)}
                className="flex justify-between items-center w-full border border-gray-300 rounded-lg px-3 h-9 bg-gray-50 text-[12px] text-gray-500 cursor-pointer focus:ring-1 focus:ring-[#632C9D]"
              >
                {formData.paymentType || "Select Payment Type"}
                <FiChevronDown
                  className={`w-4 h-4 transition-transform duration-200 ${
                    dropdownOpen ? "rotate-180" : "rotate-0"
                  }`}
                />
              </div>

              {dropdownOpen && (
                <div className="absolute z-10 left-0 right-0 bg-white mt-1 border border-gray-300 rounded-lg transition-all duration-200 text-[12px] overflow-hidden font-[600] text-gray-500">
                  {["Prepaid", "COD"].map((option) => (
                    <div
                      key={option}
                      onClick={() => {
                        setFormData({ ...formData, paymentType: option });
                        setDropdownOpen(false);
                      }}
                      className={`px-3 py-2 cursor-pointer hover:bg-purple-100 ${
                        formData.paymentType === option
                          ? "bg-purple-100 font-[600]"
                          : ""
                      }`}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Dimensions */}
            <div>
              <label className="block font-[600] mb-2 text-gray-500 text-[12px]">
                Dimensions (CM) <span className="text-red-500">*</span>
              </label>
              <div className="grid grid-cols-3 gap-4">
                <input
                  type="number"
                  name="dimensions.length"
                  required
                  value={formData.dimensions.length}
                  onChange={handleChange}
                  placeholder="L"
                  className="w-full border border-gray-300 rounded-lg px-3 h-9 bg-gray-50 text-[12px] placeholder:text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
                />
                <input
                  type="number"
                  name="dimensions.breadth"
                  required
                  value={formData.dimensions.breadth}
                  onChange={handleChange}
                  placeholder="B"
                  className="w-full border border-gray-300 rounded-lg px-3 h-9 bg-gray-50 text-[12px] placeholder:text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
                />
                <input
                  type="number"
                  name="dimensions.height"
                  required
                  value={formData.dimensions.height}
                  onChange={handleChange}
                  placeholder="H"
                  className="w-full border border-gray-300 rounded-lg px-3 h-9 bg-gray-50 text-[12px] placeholder:text-[12px] outline-none focus:ring-1 focus:ring-[#632C9D]"
                />
              </div>
            </div>
          </div>

          <div className="flex justify-start">
            <button
              type="submit"
              className="bg-[#632C9D] text-[12px] text-white font-[600] py-2 px-3 rounded-lg"
            >
              Calculate
            </button>
          </div>
        </form>

        {/* Image Section - Right Side */}
        <div className="w-full md:w-1/2 flex items-center justify-center mt-6 md:mt-0">
          <img
            src={costEstimationimg}
            alt="Illustration"
            className="hidden md:block max-w-[370px] w-full h-auto object-contain"
          />
        </div>
      </div>

      {/* Scroll to this section */}
      <div ref={resultSectionRef} className="mt-4 mx-auto w-full">
        {isDataFetched && (
          <CourierSelectionRate
            plan={courierData.filter(
              (item) => item.forward.finalCharges !== null
            )}
            isDataFetched={isDataFetched}
            loading={loading}
            hasFetched={hasFetched}
          />
        )}
      </div>

      <div className="mt-4 mx-auto w-full">
        <ImportantTerms />
      </div>
    </div>
  );
};

export default CostEstimation;